import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../web/components-v2/Theme/theme';
import { SETTINGS_SHADOW_SM } from './settingsStyles';

export const mailboxEditFormStyles = StyleSheet.create({
	section: {
		maxWidth: 640,
	},
	backButton: {
		marginLeft: -8,
		marginBottom: 8,
	},
	readonlyRow: {
		display: 'flex',
		alignItems: 'center',
		gap: 10,
		flexWrap: 'wrap' as const,
	},
	readonlyValue: {
		fontSize: 14,
		color: THEME.colors.text.main,
	},
	readonlyTag: {
		fontSize: 11,
		color: THEME.colors.text.light,
		backgroundColor: THEME.colors.pill.gray.background,
		borderRadius: 6,
		padding: '2px 8px',
	},
	aliasInputRow: {
		display: 'flex',
		gap: 8,
		alignItems: 'center',
	},
	aliasInput: {
		flex: 1,
	},
	aliasList: {
		display: 'flex',
		flexWrap: 'wrap' as const,
		gap: 6,
		marginBottom: 8,
	},
	aliasChip: {
		display: 'inline-flex',
		alignItems: 'center',
		gap: 6,
		padding: '3px 10px',
		backgroundColor: THEME.colors.background.light,
		border: `1px solid ${THEME.colors.pill.blue.border}`,
		borderRadius: 18,
		fontSize: 13,
		color: THEME.colors.text.dark,
	},
	aliasRemove: {
		display: 'inline-flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: 'auto',
		height: 'auto',
		border: 'none',
		background: 'transparent',
		cursor: 'pointer',
		padding: 0,
		fontSize: 16,
		lineHeight: 1,
		color: THEME.colors.text.light,
		':hover': {
			color: THEME.colors.text.main,
		},
	},
	activeRow: {
		padding: '4px 0 20px',
	},
	notice: {
		padding: 24,
		border: `1px solid ${THEME.colors.border.light}`,
		borderRadius: 14,
		boxShadow: SETTINGS_SHADOW_SM,
		backgroundColor: THEME.colors.background.light,
		maxWidth: 640,
	},
	noticeTitle: {
		fontFamily: THEME.typography.fontFamilies.sora,
		fontSize: 18,
		fontWeight: 600,
		margin: '0 0 8px',
		color: THEME.colors.text.main,
	},
	noticeBody: {
		fontSize: 14,
		color: THEME.colors.text.light,
		margin: '0 0 16px',
	},
});
